import { LinearProgress } from "@material-ui/core";
import { styled } from '@material-ui/core/styles';

const ProgressLine = styled(LinearProgress)(() => ({
    height: 15,
    borderRadius: 3,
}));

export default ProgressLine;